import { createSlice } from '@reduxjs/toolkit';
import $ from 'jquery';

export const settingObj = {
    navIndex: 0,
    mapIndex:0,
}

export const settingSlice = createSlice({
    name: 'setting',
    initialState: {
        navIndex: 0,
        isMobile: false,
        height: window.innerHeight > 666 ? window.innerHeight : 666,
        roleIndex: 0,
        skillIndex: 0, //0 or 1
        mapIndex:0,
        showToast: null,
        showVideoAlert: null,
        showLoading: false,
        playingMusic: false,
        showRegisterAlert: false,
        submitedEmail: null,
        submitedEmailCR: null,
        openMenu: false,
    },
    reducers: {
        setOpenMenu: (state, action) => {
            state.openMenu = action.payload;
        },
        setSubmitedEmail: (state, action) => {
            state.submitedEmail = action.payload;
        },

        setSubmitedEmailCR: (state, action) => {
            state.submitedEmailCR = action.payload;
        },

        showRegisterAlert: (state, action) => {
            state.showRegisterAlert = action.payload;
        },
        
        setPlayingMusic: (state, action) => {
            state.playingMusic = !state.playingMusic;
            const ad = $('#bg_music')[0];
            if (state.playingMusic) {
                ad.play();
            } else {
                ad.pause();
            }
        },
        setMapIndex: (state, action) => {
            state.mapIndex = action.payload;
            settingObj.mapIndex = action.payload;
        },
        showLoading: (state, action) => {
            state.showLoading = action.payload;
        },
        
        showToast: (state, action) => {
            state.showToast = action.payload;
        },
        showVideoAlert: (state, action) => {
            state.showVideoAlert = action.payload;
        },
        setNavIndex: (state, action) => {
            state.navIndex = action.payload;
            settingObj.navIndex = action.payload;
        },

        setRoleIndex: (state, action) => {
            state.roleIndex = action.payload;
        },

        setSkillIndex: (state, action) => {
            state.skillIndex = action.payload;
        },

        setIsMobile: (state, action) => {
            state.isMobile = action.payload;
        },

        refreshHeight: (state, action) => {
            state.height = window.innerHeight > 666 ? window.innerHeight : 666;
        },
    }
});

export const settingActions = settingSlice.actions
export default settingSlice.reducer
